import moment from "moment-timezone";

//Format timezone utility function
export const formatTimezone = (timezone: string) => {
  return `${timezone} (${moment.tz(timezone).format("Z")})`;
};
